import { combineReducers } from 'redux'
import PropTypes from 'prop-types'

import jobs from './jobs'
import mediaItems from './mediaItems'
import places from './places'
import company from './company'
import categories from './categories'

export default combineReducers({
  jobs,
  mediaItems,
  places,
  company,
  categories
})

export const PaginationType = PropTypes.shape({
  page: PropTypes.number,
  pageCount: PropTypes.number,
  pageSize: PropTypes.number
})

export const JobsFilterType = PropTypes.shape({
  categoryId: PropTypes.number
})

export const EmploymentTypeType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
})

export const EducationType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
})

export const CountryType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  iso3166: PropTypes.string.isRequired
})

export const JobType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  idParam: PropTypes.string.isRequired,
  isRemote: PropTypes.bool,
  zip: PropTypes.string,
  deadline: PropTypes.string,
  employmentTypeId: PropTypes.number,
  employmentType: EmploymentTypeType.isRequired,
  educationId: PropTypes.number,
  education: EducationType.isRequired,
  countryId: PropTypes.number,
  country: CountryType,
  placeId: PropTypes.string
})

export const CompanyType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  industryId: PropTypes.number,
  url: PropTypes.string,
  domain: PropTypes.string,
  desc: PropTypes.string,
  logoId: PropTypes.string,
  coverId: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  isPublic: PropTypes.bool,
  isApproved: PropTypes.bool,
  industry: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })
})

export const ImageVersionType = PropTypes.shape({
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string
})

export const ImageType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  status: PropTypes.string,
  versions: PropTypes.arrayOf(ImageVersionType)
})

export const PlaceType = PropTypes.shape({
  id: PropTypes.string,
  localityName: PropTypes.string,
  countryName: PropTypes.string
})

export const CategoryType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
})



// WEBPACK FOOTER //
// ./src/reducers/index.js